/**
 * Base configuration defaults.
 * Default desk preset, layers, theme, map position.
 */

export const DEFAULTS = {
  variant: 'general',
  theme: 'dark' as const,

  map: {
    center: [0, 20] as [number, number],
    zoom: 2,
    bearing: 0,
    pitch: 0,
    viewMode: 'flat' as const,
    minZoom: 1,
    maxZoom: 18,
  },

  panels: {
    left: true,
    right: false,
    bottom: true,
  },

  collection: {
    defaultIntervalMs: 300_000,
    minIntervalMs: 30_000,
    maxConcurrent: 4,
  },

  cache: {
    maxAge: 5 * 60 * 1000,
    staleAge: 30 * 60 * 1000,
    negativeTtl: 5 * 60 * 1000,
  },
} as const;
